import { atom, useAtomValue } from 'jotai'
import { extractMediaIdFromUrl } from '../ai-generated-label'
import { canvasOrgAssetsAtom } from './atoms'
import { useCanvasStore } from './canvas-store'

const canvasAiGeneratedMediaIdsAtom = atom<Set<string>>((get) => {
	const mediaIds = new Set<string>()
	for (const asset of get(canvasOrgAssetsAtom).media) {
		if (asset.collection === 'generated') {
			mediaIds.add(asset.id)
		}
	}
	return mediaIds
})

/**
 * The canvas document only persists image URLs, so provenance is recovered
 * by matching the media UUID embedded in the URL against the org's
 * AI-generated media.
 */
export function useIsAiGeneratedImageSrc(src: string): boolean {
	const store = useCanvasStore()
	const aiGeneratedMediaIds = useAtomValue(canvasAiGeneratedMediaIdsAtom, { store })
	const mediaId = extractMediaIdFromUrl(src)
	return mediaId !== null && aiGeneratedMediaIds.has(mediaId)
}
